import * as types from '../constants/ConfigActionTypes'

export function set (key, val) {
	return {
        type: types.SET,
        key: key,
        val: val
	}
}